var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OQInput',{attrs:{"label":_vm.label,"hint":_vm.hint,"placeholder":_vm.placeholder,"value":_vm.value,"error":_vm.invalid_email ? 'Ошибка ввода' : undefined,"type":"email"},on:{"input":_vm.doChangeEmail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }